import $ from 'jquery';
window.$ = window.jQuery = $;
// Language
if ($(".summary__closed").length > 0) {
	$(".summary__closed").on("click", function () {
		$(".summary").slideToggle(300);
	});
}